module.exports = __webpack_public_path__ + "img/1946-US.c0ab3864.png";